import styled, { css } from "styled-components";
import { device } from "../../../assets/styles/size";

export const DetalleGridWrapper = styled.div`
	position: relative;
	.slick-slider {
		.slick-list {
			margin-left: -15px;
			margin-right: -15px;
			.slick-slide {
				box-sizing: border-box;
				padding-left: 15px;
				padding-right: 15px;
			}
		}
		.slick-arrow {
			top: 0;
			position: absolute;
			height: 400px;
			&.slick-prev {
				left: 0;
			}
			&.slick-next {
				right: 0;
			}
			&.slick-disabled {
				display: none !important;
			}
		}
	}
	@media ${device.tablet} {
		margin-left: -15px;
		margin-right: -15px;
		display: flex;
		flex-wrap: wrap;
		> div {
			box-sizing: border-box;
			padding-left: 15px;
			padding-right: 15px;
			//margin-bottom: 60px;
			${(props) => {
				if (props.cols === "1") {
					return css`
						flex: 0 0 100%;
						max-width: 100%;
					`;
				} else if (props.cols === "2") {
					return css`
						flex: 0 0 100%;
						max-width: 100%;
						@media ${device.tablet} {
							flex: 0 0 50%;
							max-width: 50%;
						}
					`;
				} else if (props.cols === "3") {
					return css`
						flex: 0 0 100%;
						max-width: 100%;
						@media ${device.tablet} {
							flex: 0 0 50%;
							max-width: 50%;
						}
						@media (min-width: 1200px) {
							flex: 0 0 33.3333%;
							max-width: 33.3333%;
						}
					`;
				}
			}};
		}
	}
	${(props) => {
		props.noPaddingTopBot &&
			css`
				padding-top: 0;
				padding-bottom: 0;
			`;
		props.noPaddingTop &&
			css`
				padding-top: 0;
			`;
		props.noPaddingBot &&
			css`
				padding-bottom: 0;
			`;
	}}
`;
